.container {
  margin-inline-start: 30px;
  margin-inline-end: 10px;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
}

.transportRow {
  display: flex;
  border-bottom: 1px solid var(--separatorColor);
  padding: 10px 0 10px 10px;
  justify-content: space-between;
}
.transportRow:hover {
  background-color: var(--globalHoverBg);
}
.transportRow > div {
  display: flex;
}
.transportRow .transportRadioButton {
  display: flex;
  flex-grow: 1;
  padding-inline-end: 10px;
}
.transportRow .transportRadioButton input {
  cursor: pointer;
}
.transportRow .transportItem {
  cursor: pointer;
}

.trash,
.edit {
  mask-size: 1.3em !important;
  -webkit-mask-size: 1.3em !important;
  width: 1.3em !important;
  height: 1.3em !important;
}

.deleteButton,
.editButton {
  padding: 0 !important;
}

.editButton:last-child {
  margin-inline-end: 30px;
}

.buttonsContainer {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.addTransportButton {
  padding: 10px;
}